module.exports = __webpack_public_path__ + "static/media/icon-sms-comm-log.cf388089.svg";